import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

const accessToken = 'pk.eyJ1Ijoid2VicGFyZWJyaXNlIiwiYSI6ImNrdTVnZHU2OTFvYW0ycG8xeHduNWpvbncifQ.mw_fjiXRcHeM7GY_MVUX4Q'

const allMapGarages = document.querySelectorAll('.mapgarage')
if (allMapGarages.length) {
  mapboxgl.accessToken = accessToken

  allMapGarages.forEach(mapgarage => {

    let garage = JSON.parse(mapgarage.dataset.garage)
    console.log(garage)

    const map = new mapboxgl.Map({
      container: mapgarage,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [garage.adresse.longitude, garage.adresse.latitude],
      zoom: 12
    })

    new mapboxgl.Marker({
      color: '#f37021'
    })
      .setLngLat([garage.adresse.longitude, garage.adresse.latitude])
      .setPopup(new mapboxgl.Popup().setHTML('<div class=\'actions-popup\'>' +
                                             '<a href=\'https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=' + encodeURI(garage.adresse.address) + '\' target=\'_blank\' class=\'btn btn-secondary\'>' +
                                             '<box-icon name=\'map-alt\'></box-icon>' +
                                             'Itinéraire</a>' +
                                             '</div>'))
      .addTo(map)

  })
}



// WEBPACK FOOTER //
// ./scripts/modules/mapgarage.js